import image1 from "../assets/StampsCarouselImages/2022-08-15-Stamp-Diamond-Jubilee-Of-Pakistan-1947-2022-Commemorative-Postage-Stamp-August-14-2022.jpg";
import image2 from "../assets/StampsCarouselImages/2022-08-16-Stamp-On-The-11th-Edition-of-Int-Def-Exhi-And-Seminar-Ideas-2022-Commemorative-Postage-Stamp-August-14-2022.jpg";
import image3 from "../assets/StampsCarouselImages/2023-03-09-Stamp-International-Women-Day-Commemorative-Postage-Stamp-March-8-2023.jpg";
import image4 from "../assets/StampsCarouselImages/2023-03-15-Stamp-Golden-Jubilee-Celebrations-of-the-Senate-of-Pakistan-Commemorative-Postage-Stamp-March-15-2023.jpg";
import image5 from "../assets/StampsCarouselImages/2023-05-20-Stamp-Golden-Jubilee-Celebrations-of-NESPAK-Commemorative-Postage-Stamp-May-10-2023.jpg";

export const SliderData = [
  {
    image: image1,
    heading: "8 March, 2023",
    description: "International Women's Day Commemorative Postage-Stamp",
  },
  {
    image: image2,
    heading: "15 March, 2023",
    description:
      "Golden Jubilee Celebrations of the Senate of Pakistan Commemorative Postage Stamp",
  },
  {
    image: image3,
    heading: "10 May, 2023",
    description:
      "Golden Jubilee Celebrations of National Engineering Services Pakistan (PVT.) Limited",
  },
  {
    image: image4,
    heading: "14 August, 2022",
    description:
      "Diamond Jubilee of Pakistan (1947-2022) Commemorative Postage Stamp",
  },
  {
    image: image5,
    heading: "14 August, 2022",
    description:
      "Ideas 2022 Defence Export Promotion Organization Ministry of Defence Production, Government of Pakistan",
  },
];
